import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from './styles.scss'
import {
    Table,
    TableHead,
    TableRow,
    TableCell
} from 'react-toolbox'
import ReportHeader from '../ReportHeader'
import Section from '../ReportSection'
import classNames from 'classnames'
import T from 'i18n-react'
import CollapsableOverlay from 'components/custom/CollapsableOverlay'

class SpecTableEnterprise extends Component {

    state = {
        collapse: false
    }

    toggleCollapse = () => {
        this.setState(prevState => ({
            collapse: !prevState.collapse
        }))
    }

    renderTableRows = () => {
        const { specOrder, specData } = this.props
        return specData.map((specRow, index) => (
            <TableRow key={index}>
                {specOrder.map((nameInfo, index2) => (
                    <TableCell key={index2}>
                        {specRow[nameInfo] !== undefined ? specRow[nameInfo] : ''}
                    </TableCell>
                ))}
            </TableRow>
        ))
    }

    renderTableHead = () => {
        const { specOrder, translateKey } = this.props
        return (
            <TableHead key="header">
                {specOrder.map((info, index) => (
                    <TableCell key={`header${index}`}>
                        {T.translate(`specs.${translateKey}.${info}`)}
                    </TableCell>
                ))}
            </TableHead>
        )
    }

    renderTable = () => {
        const { collapse } = this.state
        let rows = this.renderTableRows()
        rows = collapse ? rows : rows.slice(0, 3)

        const tableClass = classNames({
            [styles.table]: true,
            [styles.tableNotCollapsed]: !collapse
        })

        return (
            <Table selectable={false} className={tableClass}>
                {this.renderTableHead()}
                {rows}
            </Table>
        )
    }


    render() {
        const { title } = this.props
        const { collapse } = this.state

        return (
            <Section>
                <ReportHeader title={title} />
                <div className={styles.tableContainer} >
                    {this.renderTable()}
                    <CollapsableOverlay collapse={collapse} toggleCollapseFunc={this.toggleCollapse} />
                </div>
            </Section>
        )
    }
}

export default CSSModules(styles)(SpecTableEnterprise)
